var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

var SvgGetPremium = function SvgGetPremium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 48c0-17.673 14.327-32 32-32 17.673 0 32 14.327 32 32 0 17.673-14.327 32-32 32-17.673 0-32-14.327-32-32zm32-36c-19.882 0-36 16.118-36 36s16.118 36 36 36 36-16.118 36-36-16.118-36-36-36zM31.536 30.72a2 2 0 0 0-3.509 1.609l4 24A2 2 0 0 0 34 58h28a2 2 0 0 0 1.973-1.671l4-24a2 2 0 0 0-3.51-1.61l-8.285 9.943-6.514-9.771a2 2 0 0 0-3.328 0l-6.514 9.77-8.286-9.941zM35.694 54l-2.509-15.053 5.279 6.333a2 2 0 0 0 3.2-.17L48 35.605l6.336 9.503a2 2 0 0 0 3.2.171l5.279-6.334L60.305 54h-24.61zM34 62a2 2 0 1 0 0 4h28a2 2 0 1 0 0-4H34z"
  })));
};

export default SvgGetPremium;